export default __webpack_public_path__ + "static/io-673b5e844b61b603b212766b45aef1e5.svg";